import { createSlice } from "@reduxjs/toolkit";

const initialaccessRoleState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  accessRoleForEdit: undefined,
  lastError: null,
  roleMaster: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const superAdminAccessRoleSlice = createSlice({
  name: "accessRole",
  initialState: initialaccessRoleState,
  reducers: {
    catchError: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      // state.error = `${action.type}: ${action.payload.error}`;
      // if (action.payload.callType === callTypes.list) {
      //   state.listLoading = false;
      // } else {
      //   state.actionsLoading = false;
      // }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getaccessRoleById
    accessRoleFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.accessRoleForEdit = action.payload.data;
    },
    // findaccessRole
    accessRolesFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    accessRoleReload: (state, action) => {
      state.accessRoleForEdit = undefined;
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },

    roleMasterFetched: (state, action) => {
      state.actionsLoading = false;
      state.roleMaster = action.payload.roleMaster;
      state.error = null;
    }
  }
});
